declare module '@fluidframework/core-interfaces' {
  // tslint:disable-next-line: interface-name
  export interface IFluidObject extends Readonly<Partial<ProvideComponentClipboardProvider>> {}
}

export interface ProvideComponentClipboardProvider {
  readonly ComponentClipboardProvider: ComponentClipboardProvider;
}

/*
 * Components should all register for the browser clipboard events on any of their HTML elements. If a component is the outermost
 * component in the selection, i.e., if it owns the selection, it should handle these events by constructing and setting the selected content
 * on the clipboard. All other components should ignore these events.
 *
 * If the selection includes nested components, the component that owns the selection should use the ComponentClipboardProvider interface
 * to acquire content to set on the clipboard from these nested components, and combine it with its own content. These nested components
 * should do the same with their own nested components. What content a component provides is entirely up to it.
 *
 * Components that can only be nested do not need to handle the browser clipboard events, they only need to implement the ComponentClipboardProvider. Only the outermost
 * component should handle these events and set the clipboard content.
 *
 */

export const fluidUrlAttributeName = 'fluid-url'; // Url for copy by reference/link
export const fluidCreateTypeAttributeName = 'fluid-create-type'; // Fluid Id of component factory
export const fluidDataTypeAttributeName = 'fluid-data-type'; // Fluid Id of component factory
export const fluidCreateDataAttributeName = 'fluid-create-data'; // Data for copy by duplication, provided to the factory
export const fluidConfigTypeAttributeName = 'fluid-config-type'; // config type of fluid component
export const fluidRenderOptionsAttributeName = 'fluid-render-options'; // config type of fluid component

export interface ComponentClipboardProvider extends ProvideComponentClipboardProvider {
  // Return a new/unattached HTMLElement representation of the entire component instance to be serialized for the html clipboard slot.
  getComponentHtmlForClipboard(): HTMLElement | undefined;

  // Returns the string representation for the entire component instance to be serialized for the clipboard plain-text clipboard slot.
  // This should likely be consistent with the IStringData produced by getData.
  getComponentTextForClipboard(): string | undefined;
}
